var _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _g4, _path7, _path8, _path9, _path10, _g5, _path11, _path12, _path13, _g6, _path14, _circle, _path15, _path16, _path17, _g7, _circle2, _path18, _path19, _path20, _g8, _path21, _g9, _path22, _path23, _path24, _g10, _path25, _path26, _g11, _g12, _g13, _g14, _path27, _g15, _path28, _g16, _g17, _g18, _path29, _path30, _path31, _g19, _path32, _path33, _path34, _g20, _g21, _circle3, _g22, _g23, _g24, _path35, _g25, _defs, _g26, _g27, _path36, _path37, _path38, _g28, _defs2, _circle4, _path39, _path40, _g29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 244,
    viewBox: "0 0 275 244",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "account",
    x: 27.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2198",
    fill: "none",
    transform: "translate(-1178 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 174",
    d: "M1178 12h24v24h-24z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 81",
    cx: 4.746,
    cy: 4.746,
    transform: "translate(1185.199 16.001)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    r: 4.746
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 556",
    d: "M1182.8 32.001a6.767 6.767 0 017-6.508 6.768 6.768 0 017 6.508",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "-1 -1 29 29",
    id: "alert",
    x: 101.31,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-329.5 -792.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(330.5 793.5)",
    fill: "none",
    stroke: "#e42322",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.2 810.012a1.2 1.2 0 11-1.2 1.2 1.211 1.211 0 011.2-1.2m.926-1.8h-1.853v-9.214h1.853z",
    fill: "#e42322"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.41,
    height: 11.41,
    viewBox: "-1 -1 11.41 11.41",
    id: "arrow-down",
    x: 260.68,
    y: 175.32999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.707 4l-4 4-4-4m4-4v8",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.12,
    height: 11.41,
    viewBox: "-1 -1 8.12 11.41",
    id: "arrow-left",
    x: 260.68,
    y: 186.73999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 699",
    d: "M5.414.707l-4 4 4 4",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.1,
    height: 29.71,
    viewBox: "-1 -1 20.1 29.71",
    id: "arrow-left-big",
    x: 61.11,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2745",
    d: "M15.975 25.586L4.243 13.854 15.975 2.122",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.12,
    height: 11.41,
    viewBox: "-1 -1 8.12 11.41",
    id: "arrow-right",
    x: 224,
    y: 145.73,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 699",
    d: "M.707.707l4 4-4 4",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.1,
    height: 29.71,
    viewBox: "-1 -1 20.1 29.71",
    id: "arrow-right-big",
    x: 81.21000000000001,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2745",
    d: "M2.121 2.121l11.732 11.732L2.121 25.585",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "basket",
    x: 53.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2200"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2197",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 180",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 112",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45 9.667a4.667 4.667 0 019.333 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 647",
    d: "M16.667 19H7.333L5 9.9h14z"
  })))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    viewBox: "-1 -1 34 34",
    id: "blocked-content",
    x: 190,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.578 24.435C2.245 21.181 1 16.954 1 15.751 1 13.716 4.56 3.035 15.75 3.035c3.651 0 6.49 1.137 8.658 2.74M30.5 1L1 30.5m11.513-11.514a4.578 4.578 0 016.473-6.473m10.242-.831c.895 1.828 1.272 3.406 1.272 4.069 0 2.034-3.56 12.715-14.75 12.715-1.488 0-2.841-.189-4.069-.521l17.547-16.263z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22.33,
    viewBox: "-1 -1 24 22.33",
    id: "booklet",
    x: 249,
    y: 129,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3.533v16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1c-2.733 0-5 1.067-5 2.533C11 2.067 8.733 1 6 1S1 2.067 1 3.533v16.8c0-1.533 2.267-2.667 5-2.667s5 1.133 5 2.667c0-1.533 2.267-2.667 5-2.667s5 1.133 5 2.667v-16.8C21 2.067 18.733 1 16 1z",
    strokeLinecap: "square"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "calendar",
    x: 79.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v24H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4V2h-2v2H9V2H7v2H3v17h18V4h-4zm2 15H5V6h2v2h2V6h6v2h2V6h2v13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "calendar-add",
    x: 105.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5h16v15H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.071 12.516l3.077 3.125 4.923-5M8 8V2m8 6V2"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.41,
    height: 10.12,
    viewBox: "-1 -1 15.41 10.12",
    id: "chevron-down",
    x: 224,
    y: 125.49,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707.707l-6 6-6-6",
    fill: "none",
    stroke: "#222",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.12,
    height: 11.41,
    viewBox: "-1 -1 8.12 11.41",
    id: "chevron-right-white",
    x: 232.12,
    y: 145.73,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M.707.707l4 4-4 4",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.41,
    height: 10.12,
    viewBox: "-1 -1 15.41 10.12",
    id: "chevron-up",
    x: 224,
    y: 135.60999999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.707 7.414l-6-6-6 6",
    fill: "none",
    stroke: "#222",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.41,
    height: 18.41,
    viewBox: "-1 -1 18.41 18.41",
    id: "close-gray",
    x: 224,
    y: 88.67,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4842",
    fill: "none",
    stroke: "#c9c9c9",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 74",
    d: "M.707.707l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 75",
    d: "M15.707.707l-15 15"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.41,
    height: 27.41,
    viewBox: "-1 -1 27.41 27.41",
    id: "close-white",
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M.707.707l24 24m0-24l-24 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "-1 -1 34 34",
    id: "email-circle-small",
    x: 190,
    y: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 16,
    cy: 16,
    r: 16
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3002",
    d: "M16 16.095l9-6.086V10H7v.009z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3003",
    d: "M16 17.905l-9-6.086V22h18V11.819z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.97,
    height: 30.13,
    viewBox: "-1 -1 14.97 30.13",
    id: "facebook",
    x: 163.68,
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.443 14.036H8.597v14.089H2.771V14.036H0V9.084h2.771v-3.2c0-2.291 1.088-5.88 5.88-5.88l4.315.019v4.806H9.834a1.186 1.186 0 00-1.236 1.349v2.915h4.356zm0 0",
    "data-name": "Group 4775"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "-1 -1 42 42",
    id: "facebook-circle",
    x: 58,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 249",
    transform: "translate(-159 -4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(159 4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.282 4143.89h-3.354v12.286h-5.081v-12.286h-2.416v-4.319h2.416v-2.794c0-2 .949-5.127 5.127-5.127l3.763.016v4.191h-2.73a1.034 1.034 0 00-1.078 1.177v2.542h3.8zm0 0",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "-1 -1 34 34",
    id: "facebook-circle-small",
    x: 190,
    y: 68,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 12",
    cx: 16,
    cy: 16,
    r: 16
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.226 15.913h-2.683v9.828h-4.065v-9.828h-1.933v-3.455h1.933v-2.237a3.812 3.812 0 014.1-4.1l3.01.013v3.353h-2.183a.827.827 0 00-.863.941v2.034h3.039zm0 0",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "filter",
    x: 131.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h24v24H0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5v-2H7v2H3v2h4v2h2v-2h12v-2zm0 11H7v2H3v2h4v2h2v-2h12v-2H9zM17 9h-2v2H3v2h12v2h2v-2h4v-2h-4z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "information",
    x: 157.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4996"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 94",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.788 18.206V9.417H11v8.789zm0-10.081V6H11v2.125z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 29.93,
    height: 29.93,
    viewBox: "-1 -1 29.93 29.93",
    id: "instagram",
    x: 31.18,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.849 8.208a10.251 10.251 0 00-.649-3.39A7.147 7.147 0 0023.115.733a10.252 10.252 0 00-3.39-.649C18.235.016 17.76 0 13.967 0S9.698.016 8.209.084a10.259 10.259 0 00-3.39.649A7.143 7.143 0 00.734 4.818a10.25 10.25 0 00-.65 3.39c-.068 1.49-.083 1.966-.083 5.759s.016 4.269.083 5.758a10.258 10.258 0 00.65 3.39A7.14 7.14 0 004.819 27.2a10.243 10.243 0 003.39.649c1.49.068 1.965.084 5.758.084s4.269-.016 5.758-.084a10.236 10.236 0 003.39-.649 7.143 7.143 0 004.085-4.085 10.259 10.259 0 00.649-3.39c.068-1.49.084-1.966.084-5.758s-.015-4.269-.084-5.759zm-2.514 11.4a7.73 7.73 0 01-.481 2.594 4.625 4.625 0 01-2.651 2.65 7.734 7.734 0 01-2.594.481c-1.472.067-1.914.081-5.644.081s-4.171-.014-5.644-.081a7.738 7.738 0 01-2.594-.481 4.626 4.626 0 01-2.65-2.65 7.742 7.742 0 01-.481-2.594c-.067-1.473-.081-1.915-.081-5.644s.014-4.171.081-5.644a7.733 7.733 0 01.481-2.593 4.624 4.624 0 012.65-2.651 7.726 7.726 0 012.594-.481c1.473-.068 1.915-.082 5.644-.082s4.171.014 5.644.082a7.722 7.722 0 012.594.481 4.623 4.623 0 012.651 2.651 7.721 7.721 0 01.481 2.593c.068 1.473.082 1.915.082 5.644s-.011 4.17-.082 5.647zM13.966 6.795a7.172 7.172 0 107.172 7.172 7.172 7.172 0 00-7.172-7.172zm0 11.828a4.656 4.656 0 114.656-4.656 4.656 4.656 0 01-4.656 4.656zm9.132-12.112a1.676 1.676 0 11-1.676-1.676 1.676 1.676 0 011.676 1.676z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "-1 -1 42 42",
    id: "instagram-circle",
    x: 100,
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 251",
    transform: "translate(-327.001 -4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 14",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(327.001 4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.977 4139.267a8.789 8.789 0 00-.556-2.906 6.127 6.127 0 00-3.5-3.5 8.789 8.789 0 00-2.907-.556c-1.277-.058-1.685-.072-4.937-.072s-3.66.014-4.937.072a8.8 8.8 0 00-2.907.556 6.124 6.124 0 00-3.5 3.5 8.787 8.787 0 00-.557 2.906c-.058 1.278-.072 1.685-.072 4.937s.014 3.66.072 4.937a8.794 8.794 0 00.557 2.907 6.121 6.121 0 003.5 3.5 8.781 8.781 0 002.907.556c1.277.058 1.685.072 4.937.072s3.66-.014 4.937-.072a8.775 8.775 0 002.907-.556 6.124 6.124 0 003.5-3.5 8.8 8.8 0 00.556-2.907c.058-1.277.072-1.685.072-4.937s-.013-3.656-.072-4.937zm-2.155 9.776a6.627 6.627 0 01-.415 2.224 3.965 3.965 0 01-2.273 2.272 6.631 6.631 0 01-2.224.413c-1.262.057-1.641.069-4.839.069s-3.576-.012-4.839-.069a6.634 6.634 0 01-2.224-.413 3.966 3.966 0 01-2.272-2.272 6.637 6.637 0 01-.413-2.224c-.057-1.263-.069-1.642-.069-4.839s.012-3.576.069-4.839a6.63 6.63 0 01.413-2.223 3.965 3.965 0 012.272-2.273 6.624 6.624 0 012.224-.412c1.263-.058 1.642-.07 4.839-.07s3.576.012 4.839.07a6.621 6.621 0 012.224.412 3.964 3.964 0 012.273 2.273 6.62 6.62 0 01.412 2.223c.058 1.263.07 1.642.07 4.839s-.009 3.579-.067 4.842zm-9.747-10.988a6.149 6.149 0 106.149 6.149 6.149 6.149 0 00-6.149-6.146zm0 10.141a3.992 3.992 0 113.991-3.991 3.992 3.992 0 01-3.991 3.994zm7.832-10.381a1.437 1.437 0 11-1.437-1.437 1.437 1.437 0 011.437 1.437z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "instagram-white",
    x: 183.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.9 7.1c0-1-.2-2-.6-2.9-.6-1.6-1.9-2.9-3.5-3.5-.9-.3-1.9-.5-2.9-.6C15.7 0 15.3 0 12 0S8.3 0 7.1.1c-1 0-2 .2-2.9.6-1.7.6-2.9 1.8-3.6 3.4-.3 1-.5 2-.5 3C0 8.3 0 8.7 0 12s0 3.7.1 4.9c0 1 .2 2 .6 2.9.6 1.6 1.9 2.9 3.5 3.5.9.3 1.9.5 2.9.6 1.2.1 1.6.1 4.9.1s3.7 0 4.9-.1c1 0 2-.2 2.9-.6 1.6-.6 2.9-1.9 3.5-3.5.3-.9.5-1.9.6-2.9.1-1.2.1-1.6.1-4.9s0-3.7-.1-4.9zm-2.1 9.7c0 .8-.1 1.5-.4 2.2-.4 1-1.2 1.9-2.3 2.3-.7.3-1.5.4-2.2.4-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-.8 0-1.5-.1-2.2-.4-1-.4-1.9-1.2-2.3-2.3-.3-.7-.4-1.5-.4-2.2-.1-1.3-.1-1.6-.1-4.8s0-3.6.1-4.8c0-.8.1-1.5.4-2.2.2-1.1 1.1-2 2.1-2.4.7-.3 1.5-.4 2.2-.4H12c3.2 0 3.6 0 4.8.1.8 0 1.5.1 2.2.4 1 .4 1.9 1.2 2.3 2.3.3.7.4 1.5.4 2.2.1 1.3.1 1.6.1 4.8v4.8zM12 5.8c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2c3.4 0 6.2-2.8 6.2-6.2 0-3.4-2.8-6.2-6.2-6.2zM12 16c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm7.8-10.4c0 .8-.6 1.4-1.4 1.4-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.18,
    height: 31.18,
    viewBox: "-1 -1 31.18 31.18",
    id: "issuu",
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.589 0H1.213A1.216 1.216 0 000 1.213v13.376A14.589 14.589 0 1014.589 0zm.01 24.612a10.129 10.129 0 1110.225-10.037 10.13 10.13 0 01-10.225 10.037zm.166-17.5a7.421 7.421 0 107.35 7.491 7.421 7.421 0 00-7.35-7.488zm-.106 11.179a3.758 3.758 0 113.792-3.722 3.759 3.759 0 01-3.792 3.725z",
    "data-name": "Group 4773"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-1 -1 32 32",
    id: "magnifying-glass-white",
    x: 74.1,
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.875 27.35L19.076 16.549a10.444 10.444 0 001.916-6.035C20.992 4.713 16.29.011 10.49.011 4.69.011-.012 4.713-.012 10.514c0 5.8 4.703 10.501 10.502 10.501a10.47 10.47 0 005.956-1.854l10.81 10.81 2.619-2.621zM10.5 17.844a7.344 7.344 0 110-14.688 7.344 7.344 0 010 14.688z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "merken",
    x: 209.41,
    y: 216.18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2202"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2192"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 180",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2178",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2012",
    d: "M5 9.729l5.528-.792L13 4l2.472 4.938L21 9.73l-4 3.843.944 5.427L13 16.438"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    d: "M3 14h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M3 17h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    d: "M3 20h8"
  })))))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon: Merken",
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "merken-star",
    x: 249,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 180",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2521",
    d: "M12.5 4l2.318 4.938L20 9.73l-3.75 3.843.885 5.427-4.635-2.562L7.864 19l.885-5.427-3.75-3.843 5.182-.792z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.038
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.02,
    height: 21.67,
    viewBox: "-1 -1 21.02 21.67",
    id: "merken-star-blue",
    x: 224,
    y: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4719"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2569",
    d: "M5.543 7.275l3.885 4.805L15.19 1.354",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4718",
    fill: "#39b9ef"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2644",
    d: "M9.091 8.482l2.184-4.065L9.509.655 7.03 5.933z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2645",
    d: "M19.017 7.918l-4.7-.718-4.554 8.478-6.658-8.235-3.108.475 4.754 4.872-1.122 6.88 5.877-3.248 5.876 3.248-1.122-6.88z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33.82,
    viewBox: "-1 -1 36 33.82",
    id: "newsletter",
    x: 38.1,
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2269"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1789",
    d: "M1 14.818v16h32v-16L17.489 22.2z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1790",
    d: "M3 16V1h28v15",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2270"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2074",
    d: "M20.209 16.02v-.737a2.332 2.332 0 01-1.92.833 2.7 2.7 0 01-2.018-.8c-.656-.7-.752-1.552-.752-2.993 0-1.425.1-2.257.736-2.961a2.687 2.687 0 012.017-.817 2.374 2.374 0 011.889.785v-.721A1.959 1.959 0 0018 6.416h-1.984a1.96 1.96 0 00-2.162 2.192v4.626a1.733 1.733 0 00.7 1.585l-1.441 1.441a3.3 3.3 0 01-1.264-2.913V8.561a4.013 4.013 0 01.992-3.026 3.968 3.968 0 013.009-.976h2.3a3.991 3.991 0 013.009.976 3.98 3.98 0 01.977 3.026v7.506zm-1.376-5.747c-1.025 0-1.313.785-1.313 2.049s.288 2.065 1.313 2.065 1.328-.8 1.328-2.065-.304-2.049-1.328-2.049z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "-1 -1 90 90",
    id: "newsletter-black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4814",
    transform: "translate(-827 -60)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 198",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(827 60)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4764",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2757",
    d: "M859.055 98.109L853 101.621v20.706h36.328v-20.706l-6.055-3.512"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2758",
    d: "M859.055 105.011V86h24.218v18.89"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 70",
    strokeLinejoin: "round",
    d: "M853 101.621l36.328 20.707"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 71",
    strokeLinejoin: "round",
    d: "M889.327 101.621l-18.648 10.051"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 72",
    strokeLinejoin: "round",
    d: "M864.861 92.861h13"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 73",
    strokeLinejoin: "round",
    d: "M864.861 98.861h13"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.24,
    height: 28.51,
    viewBox: "-1 -1 28.24 28.51",
    id: "no-ticket",
    x: 130.31,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4833",
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3875",
    d: "M0 23.74L23.74 0l2.5 2.5L2.5 26.24z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4832"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2865",
    d: "M6.469 14.821V2.514h1.186a5.933 5.933 0 005.647 4.782 5.858 5.858 0 00.74-.048L20.777.514h-3.356l-.029.971a3.924 3.924 0 01-7.845 0L9.518.514H4.469v16.307z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2866",
    d: "M20.469 10.72v13.794h-.876a5.882 5.882 0 00-9.311-3.607l-1.253 1.254a5.8 5.8 0 00-1.066 2.353H6.676l-2 2h5.15l.028-.972a3.931 3.931 0 013.922-3.813h.113a3.927 3.927 0 013.812 3.812l.028.972h4.74V8.72z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2867",
    d: "M15.209 16.113h2.76v-2h-.76z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "play",
    x: 249,
    y: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 180",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5316"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 227",
    transform: "translate(4 4)",
    fill: "none",
    stroke: "#ff7800",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 2",
    d: "M15.417 12.087l-4.757 2.854V9.233z",
    fill: "#ff7800"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "-1 -1 26 32",
    id: "play-no-border",
    x: 106.1,
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l24 15L0 30z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.41,
    height: 18.41,
    viewBox: "-1 -1 18.41 18.41",
    id: "reset",
    x: 224,
    y: 107.08,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5143",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 74",
    d: "M.707.707l15 15"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 75",
    d: "M15.707.707l-15 15"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "search",
    x: 249,
    y: 52,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1699",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 181",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 116",
    transform: "translate(5.57 5.599)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.715,
    cy: 4.715,
    r: 4.715
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    d: "M13.716 13.145L8.001 7.43"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.1,
    height: 37,
    viewBox: "-1 -1 38.1 37",
    id: "search-big",
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.8,
    cy: 12.8,
    r: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4 34.3L21.1 19.9"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 26 26",
    id: "share",
    x: 249,
    y: 78,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 19L11 12 4 9.667 18 5z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.68,
    height: 23,
    viewBox: "-1 -1 11.68 23",
    id: "share-facebook",
    x: 249,
    y: 175.32999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.292 10.481H6.419V21h-4.35V10.481H0v-3.7h2.069V4.39A4.08 4.08 0 016.459 0l3.222.014V3.6H7.343a.886.886 0 00-.923 1.007v2.177h3.252zm0 0"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "-1 -1 21 17",
    id: "share-mail",
    x: 224,
    y: 71.67,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#111",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.652 1.829l7.826 6.357 7.826-6.357"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M1 1h17v13H1z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 23 23",
    id: "share-twitter",
    x: 249,
    y: 198.32999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.301 8.759L19.996 0h-1.823l-6.684 7.604L6.154 0H0l8.069 11.5L0 20.682h1.823l7.054-8.031 5.635 8.031h6.154M2.481 1.346h2.8l12.89 18.057h-2.8",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22.09,
    viewBox: "-1 -1 22 22.09",
    id: "share-whatsapp",
    x: 249,
    y: 221.32999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.09l1.413-5.159a9.959 9.959 0 118.629 4.986 9.954 9.954 0 01-4.759-1.212zm5.528-3.19l.3.179a8.266 8.266 0 004.213 1.153 8.276 8.276 0 10-7.013-3.873l.2.313-.836 3.053z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.553 5.793c-.2-.485-.407-.419-.56-.427s-.311-.009-.477-.009a.914.914 0 00-.664.311 2.789 2.789 0 00-.871 2.075 4.838 4.838 0 001.016 2.573 11.09 11.09 0 004.251 3.756 14.328 14.328 0 001.418.524 3.413 3.413 0 001.567.1 2.563 2.563 0 001.679-1.183 2.079 2.079 0 00.145-1.183c-.062-.1-.228-.166-.477-.291s-1.472-.726-1.7-.809-.394-.125-.56.125-.643.809-.788.975-.29.187-.539.062a6.8 6.8 0 01-2-1.235 7.5 7.5 0 01-1.384-1.723c-.145-.249-.015-.384.109-.508s.249-.291.373-.436a1.7 1.7 0 00.249-.415.458.458 0 00-.021-.436c-.061-.124-.559-1.348-.766-1.846z",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.58,
    height: 31.58,
    viewBox: "-1 -1 31.58 31.58",
    id: "spotify",
    x: 132.1,
    y: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3368"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1695",
    d: "M14.789 0a14.789 14.789 0 1014.788 14.789A14.789 14.789 0 0014.789 0zm6.782 21.331a.921.921 0 01-1.267.307c-3.473-2.123-7.844-2.6-12.992-1.426a.923.923 0 11-.41-1.8c5.633-1.288 10.466-.734 14.364 1.648a.922.922 0 01.305 1.271zm1.81-4.027a1.154 1.154 0 01-1.586.38A19.411 19.411 0 007.058 15.96a1.153 1.153 0 11-.67-2.206 21.574 21.574 0 0116.613 1.969 1.153 1.153 0 01.379 1.581zm.156-4.193c-4.767-2.831-12.63-3.091-17.181-1.71a1.383 1.383 0 11-.8-2.647c5.224-1.586 13.908-1.279 19.4 1.978a1.383 1.383 0 01-1.412 2.379z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "-1 -1 20 28",
    id: "ticket",
    x: 186.79000000000002,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2383",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 820",
    d: "M13.923 1a4.925 4.925 0 01-9.846 0H1v24h3.385a4.925 4.925 0 019.846 0H17V1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 13",
    d: "M4.5 14.6h9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 14",
    d: "M5.301 14.6h6.6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    d: "M4.5 14.6h9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    d: "M4.5 14.6h9"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Komponente 42 \\u2013 30",
    width: 58,
    height: 58,
    viewBox: "-1 -1 58 58",
    id: "ticket-available",
    x: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 92",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#41cbff"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1738",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 820",
    d: "M32.923 16a4.925 4.925 0 01-9.846 0H20v24h3.385a4.925 4.925 0 019.846 0H36V16z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1807"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 13",
    d: "M23.5 29.6h9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 14",
    d: "M24.3 29.6h6.6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 15",
    d: "M23.5 29.6h9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linie 16",
    d: "M23.5 29.6h9"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.24,
    height: 28.51,
    viewBox: "-1 -1 28.24 28.51",
    id: "ticket-sold-out",
    x: 158.55,
    y: 185,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.74L23.74 0l2.5 2.5L2.5 26.24zm6.469-8.919V2.514h1.186a5.933 5.933 0 005.647 4.782 5.858 5.858 0 00.74-.048L20.777.514h-3.356l-.029.971a3.924 3.924 0 01-7.845 0L9.518.514H4.469v16.307zm14-4.101v13.794h-.876a5.882 5.882 0 00-9.311-3.607l-1.253 1.254a5.8 5.8 0 00-1.066 2.353H6.676l-2 2h5.15l.028-.972a3.931 3.931 0 013.922-3.813h.113a3.927 3.927 0 013.812 3.812l.028.972h4.74V8.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.209 16.113h2.76v-2h-.76z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Komponente 42 \\u2013 31",
    width: 58,
    height: 58,
    viewBox: "-1 -1 58 58",
    id: "ticket-unavailable",
    y: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4632",
    fill: "#efefef"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4629"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4627"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2493",
    d: "M25.277 21.1a5.922 5.922 0 01-3.092-4.1H21v8.373z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2494",
    d: "M30.687 34.73a5.926 5.926 0 013.436 4.269H35v-8.582z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4628"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2495",
    d: "M19 27.635V14.999h5.049l.028.972a3.92 3.92 0 002.916 3.671L42.557 4.078A28 28 0 004.078 42.557z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2496",
    d: "M52.037 13.638L37 28.673v12.324h-4.74l-.029-.971a3.919 3.919 0 00-2.914-3.67L13.639 52.035a28 28 0 0038.4-38.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 3802",
    d: "M2.67 47.515L47.805 2.38l6.084 6.085L8.755 53.6z"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    fill: "none",
    viewBox: "-1 -1 25 28",
    id: "tiktok",
    x: 224,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.82 0c.428 3.69 2.488 5.89 6.068 6.123v4.15c-2.075.203-3.893-.476-6.006-1.755v7.761c0 9.86-10.75 12.94-15.07 5.874C-.965 17.605.735 9.626 9.643 9.306v4.376c-.679.109-1.404.28-2.067.507-1.981.67-3.105 1.926-2.793 4.142.601 4.243 8.386 5.499 7.738-2.793V.008h4.298V0z",
    fill: "#000"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "-1 -1 42 42",
    id: "tiktok-circle",
    x: 148,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.587 10.833l3.16.07c-.017 1.297.357 2.46 1.247 3.405.92.977 2.178 1.156 3.478 1.19v3.21c-1.69.067-3.252-.352-4.718-1.196-.01.044-.025.078-.024.112.008 1.85.011 3.699.027 5.548.013 1.362-.353 2.608-1.186 3.709-.868 1.145-2.046 1.848-3.47 2.134-1.902.382-3.669.055-5.219-1.12-1.17-.888-1.82-2.085-2.095-3.49-.216-1.1-.155-2.177.297-3.206.866-1.97 2.395-3.175 4.559-3.612a5.595 5.595 0 011.932-.032c.054.008.139.086.139.131.007.977.004 1.953.002 2.929 0 .017-.012.035-.018.052-.241-.04-.479-.091-.72-.116-1.465-.15-2.894.897-3.095 2.31-.186 1.306.37 2.506 1.662 3.031 1.223.498 2.691.156 3.496-.835.438-.54.547-1.177.547-1.846-.003-4.033-.002-8.065-.002-12.098v-.28z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "-1 -1 20 24",
    id: "trash",
    x: 249,
    y: 151.32999999999998,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 4737",
    fill: "none",
    stroke: "#111",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2698",
    d: "M0 5h18"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2699",
    d: "M16 5v14a2 2 0 01-2 2H4a2 2 0 01-2-2V5m3 0V3a2 2 0 012-2h4a2 2 0 012 2v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2700",
    d: "M7 10v6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2701",
    d: "M11 10v6"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.32,
    height: 22,
    viewBox: "-1 -1 19.32 22",
    id: "trash-merklist",
    x: 224,
    y: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4741"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4739"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4738",
    transform: "translate(1.103 .531)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2702",
    d: "M.011 2.652L1.69 16.446c.113 1.123 2.692 2.022 5.866 2.022s5.752-.9 5.866-2.022l1.676-13.794"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 144",
    cx: 7.5,
    cy: 2.5,
    rx: 7.5,
    ry: 2.5,
    transform: "translate(0 .469)"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 91",
    fill: "none",
    stroke: "#000",
    d: "M8.693 8.506V15.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 92",
    fill: "none",
    stroke: "#000",
    d: "M4.929 8.929l.627 6.456"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 93",
    fill: "none",
    stroke: "#000",
    d: "M12.457 8.929l-.627 6.456"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "-1 -1 25 25",
    id: "twitter",
    x: 249,
    y: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8955 4.33181C23.8361 5.27803 23.7514 6.21854 23.6656 7.16019C23.5875 8.02747 23.5512 8.89933 23.3532 9.74372C22.9221 11.5801 21.765 12.7037 20.0458 13.2346C19.1604 13.5092 18.2541 13.5401 17.3422 13.4897C17.2488 13.4863 17.1575 13.4703 17.064 13.4737C16.9969 13.468 16.9386 13.4211 16.8693 13.4257C16.9386 13.4222 16.9947 13.4703 17.0618 13.4737C17.1454 13.4703 17.2301 13.4703 17.2994 13.5321C18.2519 13.7598 19.1692 14.0744 19.982 14.6556C20.6376 15.1225 21.1479 15.7071 21.3195 16.5469C21.4614 17.2289 21.3382 17.8788 21.0192 18.4749C20.2361 19.936 19.1098 21.0367 17.6447 21.7094C16.3457 22.3078 15.1204 21.9486 14.1305 20.7907C13.3364 19.8582 12.8337 18.7552 12.4136 17.6053C12.2794 17.23 12.154 16.8547 12.0154 16.4531C11.9241 16.5538 11.9065 16.6614 11.8768 16.7563C11.5424 17.7655 11.1784 18.7643 10.6438 19.6831C10.3336 20.2174 9.97837 20.7186 9.52851 21.1408C8.54739 22.0527 7.44199 22.2563 6.25739 21.6671C4.8396 20.9692 3.7111 19.9062 2.97306 18.4566C2.29112 17.1156 2.60349 15.7998 3.7507 14.8604C4.55803 14.1991 5.49735 13.8479 6.47847 13.5858C6.55106 13.5664 6.62585 13.5492 6.69845 13.5332C6.76554 13.4714 6.84804 13.4714 6.93053 13.4749C6.98882 13.4863 7.03502 13.4188 7.07792 13.4337C7.03502 13.4062 6.98992 13.4863 6.93053 13.4749C6.83924 13.4714 6.74904 13.4863 6.65775 13.4909C5.70083 13.5458 4.75601 13.5069 3.83429 13.1991C2.17123 12.6453 1.06582 11.5252 0.643459 9.74487C0.479572 9.04464 0.445475 8.32381 0.373981 7.61443C0.224394 6.09497 0.111103 4.57094 0.0176114 3.04462C-0.0197855 2.43478 -0.0109862 1.82608 0.178198 1.23912C0.485072 0.284885 1.23961 -0.143034 2.25922 0.0423212C3.42512 0.259713 4.41504 0.854681 5.33236 1.59496C6.92393 2.88215 8.22072 4.46224 9.42952 6.12357C10.3754 7.42221 11.2422 8.7769 11.9516 10.23C11.9615 10.2494 11.9736 10.2655 11.9857 10.2849C12.0528 10.2769 12.055 10.2174 12.0737 10.1739C13.2363 7.85928 14.7102 5.77346 16.3842 3.83409C17.2565 2.82494 18.1925 1.88443 19.288 1.13271C20.0414 0.615549 20.8367 0.189919 21.7397 0.0457537C22.3842 -0.0572214 23.0013 0.00914027 23.4665 0.56635C23.7855 0.94507 23.9021 1.41532 23.9615 1.9096C24.0583 2.71853 23.9483 3.52631 23.8966 4.33181",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    viewBox: "-1 -1 42 42",
    id: "twitter-circle",
    x: 148,
    y: 42,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 39.986c11.041 0 19.992-8.951 19.992-19.993C40.042 8.95 31.092 0 20.05 0 9.008 0 .056 8.951.056 19.993c0 11.042 8.952 19.993 19.993 19.993z",
    fill: "#020203"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.462 18.159l9.41-10.71h-2.228l-8.17 9.299-6.518-9.298H7.42l9.863 14.053-9.863 11.23h2.23l8.62-9.82 6.886 9.82h7.52M10.455 9.087h3.428l15.76 22.067h-3.428",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    viewBox: "-1 -1 34 34",
    id: "twitter-circle-small",
    x: 190,
    y: 102,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cda)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.04 31.989c8.833 0 15.994-7.161 15.994-15.995C32.034 7.161 24.873 0 16.039 0 7.206 0 .045 7.16.045 15.994S7.205 31.99 16.039 31.99z",
    fill: "#020203"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.97 14.527l7.529-8.567h-1.784l-6.535 7.438-5.215-7.438H5.938l7.89 11.242-7.89 8.985H7.72l6.897-7.856 5.508 7.856h6.016M8.364 7.27h2.743l12.608 17.654h-2.743",
    fill: "#fff"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cda"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "-1 -1 34 34",
    id: "whatsapp-circle-small",
    x: 190,
    y: 136,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 221",
    cx: 16,
    cy: 16,
    r: 16
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3001",
    d: "M25 15.966a8.974 8.974 0 01-8.962 8.959 8.958 8.958 0 01-4.283-1.091L7.004 25.08l1.271-4.643a8.942 8.942 0 01-1.2-4.479 8.973 8.973 0 018.962-8.959 8.906 8.906 0 016.34 2.628A8.9 8.9 0 0125 15.966zm-10.512-2.09a.412.412 0 01.019.392 1.527 1.527 0 01-.224.374c-.112.131-.235.292-.336.392s-.229.233-.1.457a6.747 6.747 0 001.246 1.551 6.118 6.118 0 001.8 1.111c.224.112.355.093.485-.056s.56-.654.709-.878.3-.187.5-.112 1.306.616 1.53.728.373.168.429.261a1.87 1.87 0 01-.131 1.065 2.306 2.306 0 01-1.512 1.065 3.071 3.071 0 01-1.41-.089 12.9 12.9 0 01-1.277-.472 9.981 9.981 0 01-3.826-3.38 4.354 4.354 0 01-.914-2.316 2.51 2.51 0 01.784-1.868.823.823 0 01.6-.28c.149 0 .3 0 .429.008s.322-.052.5.384.643 1.551.699 1.663z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.18,
    height: 23.12,
    viewBox: "-1 -1 34.18 23.12",
    id: "youtube",
    x: 90,
    y: 58,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.767 14.454V6.018l8.7 4.233-8.694 4.2zm19.091-9.9a6.239 6.239 0 00-1.279-2.981A4.788 4.788 0 0027.354.301c-4.5-.3-11.258-.3-11.258-.3h-.014s-6.755 0-11.258.3a4.79 4.79 0 00-3.225 1.272A6.243 6.243 0 00.32 4.554a42.433 42.433 0 00-.322 4.86v2.278a42.433 42.433 0 00.322 4.86 6.243 6.243 0 001.279 2.981 5.7 5.7 0 003.55 1.285c2.574.231 10.941.3 10.941.3s6.762-.01 11.264-.313a4.788 4.788 0 003.225-1.272 6.239 6.239 0 001.279-2.981 42.529 42.529 0 00.321-4.86V9.416a42.529 42.529 0 00-.321-4.86z",
    "data-name": "Group 4776"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "-1 -1 42 42",
    id: "youtube-circle",
    x: 148,
    y: 84,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-327.001 -4124)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(327.001 4124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.522 4146.781v-6.294l6.485 3.157-6.484 3.135zm14.238-7.382a4.653 4.653 0 00-.954-2.223 3.571 3.571 0 00-2.4-.948c-3.358-.226-8.4-.226-8.4-.226h-.01s-5.038 0-8.4.226a3.572 3.572 0 00-2.4.948 4.656 4.656 0 00-.954 2.223 31.647 31.647 0 00-.24 3.624v1.7a31.647 31.647 0 00.24 3.624 4.656 4.656 0 00.954 2.223 4.249 4.249 0 002.646.957c1.92.172 8.16.225 8.16.225s5.043-.007 8.4-.234a3.571 3.571 0 002.4-.948 4.653 4.653 0 00.954-2.223 31.719 31.719 0 00.239-3.624v-1.7a31.719 31.719 0 00-.239-3.624z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/Sprite.701aa2702fdb3bf7a4828560a0325398.svg";
export { ForwardRef as ReactComponent };